import React, { useEffect, useState } from 'react'
import AddButtonPage from '../../../../Components/AddButtonPage/AddButtonPage'
import Events from './Events'
import CustomTable from '../../../../Components/Table/CustomTable'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../../ReduxStore/actions'
// import { Button } from '@mui/material'
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader'
import { toast } from 'react-toastify'

const EventHome = () => {

  const tableData = [
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },

  ];
  const tableHeadData = ['S.No', 'Campus Name', 'Event Title', "Requirements", 'Event start Date', 'Event End Date', "Actions"]




  const dispatch = useDispatch();

  const { EventGetAll } = useSelector(state => state?.EventGetAll);
  const { updateEvent } = useSelector(state => state?.updateEvent);
  const { deleteEvent } = useSelector(state => state?.deleteEvent);



  console.log(EventGetAll, "EventGetAllEventGetAll")
  const { EventPost } = useSelector(
    (state) => state?.EventPost
  );
  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllEvents`,
      };

      const responseData = await dispatch(actions.EVENTGETALL(data1));
      // if (responseData?.payload?.message === "Events Fetched successfully!") {

      // }
      console.log(responseData, "responseDataaa")
      // setResponseTableData(responseData?.payload)

    }


    fetchData();

  }, [EventPost, updateEvent, deleteEvent]);

  useEffect(() => {
    const tempArr = [];

    EventGetAll?.data?.map((data, index) => {
      return tempArr.push({
        id: data?.event_id,
        campusName: data?.campus_name || '--',
        eventTitle: data?.event_title || '--',
        requirements: data?.requirements || '--',
        evenetStartDate: data?.from_date || '--',
        evenetEndDate: data?.to_date || '--',

      });
    });
    setRowTableData(tempArr);


  }, [EventGetAll]);

  
  const handleDeleteById = async (id) => {
    const data1 = {
      data: {},
      method: "delete",
      apiName: `deleteEvent/${id}`,
    };

    const responseData = await dispatch(actions.DELETEEVENT(data1));
    if (responseData?.payload?.message === "Event deleted successfully.") {
      toast.success(responseData?.payload?.message)

    } else {
      toast.error(responseData?.payload?.message)


    }


  }



  return (
    <div>
      {/* {loading && <FullPageLoader />} */}


      <AddButtonPage addComponent={Events} title="Events" handleDeleteById={handleDeleteById} tableData={rowTableData} tableHeadData={tableHeadData} />


    </div>
  )
}

export default EventHome